import React, { useState, useEffect, useCallback } from "react";
import { Table, Button, Modal, Row, Col } from "react-bootstrap";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import "./ProductTable.css";
import axios from "axios";
import baseURL from "../../../../../../Url/NodeBaseURL"

const ProductTable = ({
  estimate_number,
  products,
  onDelete,
  onEdit,
  estimate_date,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleView = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  // Function to check if a date is today (same as Sales table)
  function isCurrentDate(dateString) {
    const today = new Date();
    const date = new Date(dateString);

    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }

  //disabling actions when a bill is already created
    const [generateSales, setGenerateSales] = useState(true);
    const checkEstimateDetails = useCallback(async (estimate_number) => {
      try {
        const response = await axios.get(
          `${baseURL}/Estimate/estimate/${estimate_number}`
        );
        console.log("response is", response.data)
        
        if (response.data.repair_details_id) {
          setGenerateSales(false);
        } else {
          setGenerateSales(true);
        }
      } catch (error) {
        console.error('Error fetching estimate details:', error);
      }
    }, []);
    useEffect(() => {
      if (estimate_number) {
        checkEstimateDetails(estimate_number);
      }
    }, [estimate_number, checkEstimateDetails]);

  return (
    <div className="product-table-wrapper">
      <Table className="dataTable_headerCell1" bordered hover responsive>
        <thead
          style={{
            position: "sticky",
            top: 0,
            background: "white",
            zIndex: 2,
            fontSize: "13px",
          }}
        >
          <tr>
            <th>S No</th>
            <th>BarCode</th>
            <th>Product Name</th>
            <th>Metal</th>
            <th>Purity</th>
            <th>Gr Wt</th>
            <th>St Wt</th>
            <th>VA%</th>
            <th>Total Wt</th>
            <th>Rate</th>
            <th>MC</th>
            <th>Discount</th>
            <th>Fest Discount</th>
            <th>Tax %</th>
            <th>Tax Amt</th>
            <th>Total Price</th>
            <th>Image</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {products.length > 0 ? (
            products.map((product, index) => {
              const isToday = isCurrentDate(estimate_date);
              return (
              <tr key={product.id || index} className="table-values-sales">
                <td>{index + 1}</td>
                <td>{product.code}</td>
                <td>{product.product_name}</td>
                <td>{product.metal_type}</td>
                <td>
                  {product.pricing === "By Weight"
                    ? product.selling_purity !== undefined &&
                      product.selling_purity !== ""
                      ? product.selling_purity
                      : product.purity
                    : product.printing_purity !== undefined &&
                      product.printing_purity !== ""
                    ? product.printing_purity
                    : product.purity}
                </td>
                <td>{product.gross_weight}</td>
                <td>{product.stone_weight}</td>
                <td>{product.va_percent || product.va_perc || "0"}</td>
                <td>{product.total_weight_av}</td>
                <td>{product.pieace_cost ? product.pieace_cost : product.rate}</td>
                <td>{product.making_charges}</td>
                <td>{product.disscount}</td>
                <td>{product.festival_discount}</td>
                <td>{product.tax_percent}</td>
                <td>{product.tax_amt}</td>
                <td>{product.total_price}</td>
                <td>
                  {(() => {
                    const imageSrc = product.imagePreview || product.image || product.product_image;
                    console.log('Product image data:', {
                      imagePreview: product.imagePreview,
                      image: product.image,
                      product_image: product.product_image,
                      finalSrc: imageSrc,
                      hasImage: !!imageSrc
                    });
                    return imageSrc ? (
                      <img
                        src={imageSrc}
                        alt="Uploaded"
                        style={{ width: "50px", height: "50px" }}
                        onError={(e) => {
                          console.error('Image failed to load:', e.target.src);
                          // Show a fallback when image fails to load
                          e.target.style.display = 'none';
                          const fallback = document.createElement('span');
                          fallback.textContent = 'Image Available';
                          fallback.style.color = '#28a745';
                          fallback.style.fontSize = '12px';
                          e.target.parentNode.appendChild(fallback);
                        }}
                        onLoad={() => {
                          console.log('Image loaded successfully');
                        }}
                      />
                    ) : (
                      "No Image"
                    );
                  })()}
                </td>
                <td>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <FaEye
                      onClick={() => handleView(product)}
                      style={{
                        cursor: "pointer",
                        marginLeft: "10px",
                        color: "green",
                      }}
                    />
                    <FaEdit
                      onClick={() => {
                        if (generateSales) { 
                          onEdit(index);
                        }
                      }}
                      style={{
                        cursor: generateSales?"pointer":"not-allowed",
                        marginLeft: "10px",
                        color: generateSales?"blue": "gray", 
                      }}
                    />
                    <FaTrash
                      onClick={() => {
                        if (generateSales && isToday) { 
                          onDelete(index);
                        }
                      }}
                      style={{
                        cursor: (generateSales && isToday)?"pointer":"not-allowed",
                        marginLeft: "10px",
                        color: (generateSales && isToday)?"red":"gray",
                      }}
                    />
                  </div>
                </td>
              </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="18" className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
        {products.length > 0 && (
          <tfoot style={{ fontSize: "12px" }}>
            <tr style={{ fontWeight: "bold", background: "#f8f9fa" }}>
              <td>{products.length}</td>
              <td colSpan="4"></td>
              <td>
                {products
                  .reduce(
                    (sum, item) => sum + parseFloat(item.gross_weight || 0),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td>
                {products
                  .reduce(
                    (sum, item) => sum + parseFloat(item.stone_weight || 0),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td></td>
              <td>
                {products
                  .reduce(
                    (sum, item) => sum + parseFloat(item.total_weight_av || 0),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td colSpan="9"></td>
            </tr>
          </tfoot>
        )}
      </Table>

      {/* Product Details Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Product Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedProduct && (
            <Table
              className="dataTable_headerCell1"
              bordered
              hover
              responsive
              size="sm"
              style={{ backgroundColor: "#fff" }}
            >
              <tbody>
                {(() => {
                  // Define all possible fields with their display names
                  const fields = [
                    { key: "code", label: "BarCode" },
                    { key: "metal_type", label: "Metal" },
                    { key: "pricing", label: "Pricing" },
                    { key: "weight_bw", label: "Weight BW" },
                    { key: "va_percent", label: "VA%" },
                    { key: "rate", label: "Rate" },
                    { key: "mc_per_gram", label: "MC %" },
                    { key: "disscount_percentage", label: "Discount %" },
                    { key: "tax_amt", label: "Tax Amount" },
                    { key: "category", label: "Category" },
                    { key: "design_name", label: "Design Name" },
                    { key: "gross_weight", label: "Gross Weight" },
                    { key: "stone_price", label: "Stone Price" },
                    { key: "wastage_weight", label: "Wastage Wt" },
                    { key: "rate_amt", label: "Metal Amount" },
                    { key: "making_charges", label: "Total MC" },
                    { key: "disscount", label: "Discount" },
                    { key: "total_price", label: "Total Price" },
                    { key: "product_name", label: "Sub Category" },
                    { key: "purity", label: "Purity" },
                    { key: "stone_weight", label: "Stone Weight" },
                    { key: "va_on", label: "Wastage on" },
                    { key: "total_weight_av", label: "Total Weight" },
                    { key: "mc_on", label: "MC On" },
                    { key: "hm_charges", label: "HM Charges" },
                    { key: "tax_percent", label: "Tax %" },
                    { key: "remarks", label: "Remarks" },
                  ];

                  // Filter out fields that don't have data
                  const validFields = fields.filter((field) => {
                    const value = selectedProduct[field.key];
                    return (
                      value !== null &&
                      value !== undefined &&
                      value !== "" &&
                      value !== "0" &&
                      value !== 0 &&
                      value !== "0.00" &&
                      parseFloat(value) !== 0
                    );
                  });

                  // Create rows with 6 columns each (3 key-value pairs per row)
                  const rows = [];
                  for (let i = 0; i < validFields.length; i += 3) {
                    const rowFields = validFields.slice(i, i + 3);
                    rows.push(rowFields);
                  }

                  return rows.map((rowFields, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className="table-values-sales"
                      style={{
                        backgroundColor:
                          rowIndex % 2 === 0 ? "#f8f9fa" : "#fff",
                        borderBottom: "1px solid #e9ecef",
                      }}
                    >
                      {rowFields.map((field, colIndex) => (
                        <React.Fragment key={colIndex}>
                          {/* Key Column */}
                          <td
                            style={{
                              width: "16.66%",
                              padding: "6px 8px",
                              textAlign: "left",
                              borderRight: "1px solid #e9ecef",
                              borderBottom: "1px solid #e9ecef",
                              backgroundColor: "#f8f9fa",
                            }}
                          >
                            <div style={{ textAlign: "left" }}>
                              <strong
                                style={{
                                  fontSize: "10px",
                                  color: "#6B451E",
                                  fontWeight: "600",
                                }}
                              >
                                {field.label}
                              </strong>
                            </div>
                          </td>
                          {/* Value Column */}
                          <td
                            style={{
                              width: "16.66%",
                              padding: "6px 8px",
                              textAlign: "left",
                              borderRight: "1px solid #e9ecef",
                              borderBottom: "1px solid #e9ecef",
                            }}
                          >
                            <div style={{ textAlign: "left" }}>
                              <span
                                style={{
                                  fontSize: "11px",
                                  color: "#495057",
                                  fontWeight: "500",
                                }}
                              >
                                {selectedProduct[field.key]}
                              </span>
                            </div>
                          </td>
                        </React.Fragment>
                      ))}
                      {/* Fill remaining columns if row has less than 3 fields */}
                      {rowFields.length < 3 &&
                        Array.from({ length: (3 - rowFields.length) * 2 }).map(
                          (_, emptyIndex) => (
                            <td
                              key={`empty-${emptyIndex}`}
                              style={{
                                width: "16.66%",
                                padding: "6px 8px",
                                borderRight: "1px solid #e9ecef",
                                borderBottom: "1px solid #e9ecef",
                                backgroundColor:
                                  emptyIndex % 2 === 0 ? "#f8f9fa" : "#fff",
                              }}
                            ></td>
                          )
                        )}
                    </tr>
                  ));
                })()}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProductTable;
